import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";



import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
window.JSZip = jzip;
require( 'datatables.net-buttons/js/buttons.html5.min' );

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class TransfusionStatisticsVolume extends Component{
constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.setTable = this.setTable.bind(this);

		this.state = {
			start_date:"",
			end_date:"",
			type:"",
			filename:'Estadistica Unidades por Volumen',
			listado:[],
			list_pdf:[],
			columns:[
				{title:'TIPO DE COMPONENTE'},
				{title:'UNIDADES CON VOLUMEN'},
				{title:'VOLUMEN (ml)'},
				{title:'UNIDADES SIN VOLUMEN'},
			],
			date_hour:"",
			medical:"",
			totales:[],
			work_session: "all",
			sessions: [],
			include_returns:'false'
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
			  });
			}})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	componentDidMount(){
		//this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
				method: 'get',
				headers: new Headers({
					'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then(response => {
				var aux = response.split('|');
				var date = aux[0].split("/");
				var hours = this.getHourFormat(aux[1]);
	
				this.setState({
					start_date:date[2]+'-'+date[1]+'-'+date[0],
					end_date:date[2]+'-'+date[1]+'-'+date[0],
					date_hour:aux[0]+' '+hours,
				});
			})

		this.setTable();
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		
			
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		const startDate = this.state.start_date;
		const endDate   = this.state.end_date;
		const title = this.state.filename;
		const h_name = sessionStorage.getItem('health_facilities_name');
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
					extend: 'excelHtml5',
					title:this.state.filename,
					customize: function (xlsx) {
						
						const sheet = xlsx.xl.worksheets['sheet1.xml'];
						const sheetData = $('sheetData', sheet);
						

						const fecha = startDate +" al "+endDate;

					 // recorrer filas actuales y moverlas +2
						$('row', sheetData).each(function () {
							const r = parseInt($(this).attr('r'));
							if (r > 1) { 
								$(this).attr('r', r + 2);

								$(this).find('c').each(function () {
									const ref = $(this).attr('r');
									const col = ref.replace(/[0-9]/g, '');
									$(this).attr('r', col + (r + 2));
								});
							}
						});

						// insertar filas válidas
						const filas = `
							<row r="2">
								<c r="A2" t="inlineStr">
									<is><t>${h_name}</t></is>
								</c>
							</row>
							<row r="3">
								<c r="A3" t="inlineStr">
									<is><t>Información del: ${fecha} </t></is>
								</c>
							</row>
							
						`;
						
						 $('row[r="1"]', sheetData).after(filas);
						

						// ✨ Negrita al título
					
						$('c[r="A1"]', sheet).attr('s', '2');
					},
					
				},
				{
					extend: 'pdf',
					title: this.state.filename,
					customize: (doc)=> { 
						doc.content.unshift({
							image: this.props.header_document,
							//text:'encabezado',
							alignment:'center',
							width:this.props.w_head
						});

						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						doc.content[3].table.body.map((b, i)=>{
							b.map((item, j)=>{
								if(item.text === 'TOTALES'){
									item.alignment = 'right';
								}else{
									if(j > 0){
										item.alignment = 'right';
									}
								}
																	
							})
						})
						//doc.content[3].table.widths=["50%","5%","5%","5%","5%","5%","5%","5%","5%","10%"];
						
						doc.styles.tableHeader.fontSize = 6.5;
						doc.defaultStyle.fontSize = 6.5; 
						doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
					} 
				}
			],
			// columnDefs: [
			// 	{
			// 		targets: [1,2,3,4,5,6,7,8,9],
			// 		className: 'dt-right'
			// 	},
			// ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				data.map((d, i)=>{
					
					if(i > 0){
						$('td:eq('+i+')', row).attr('style', 'text-align: right;');
					}else{
						$('td:eq('+i+')', row).attr('style', 'text-align: left;');
					}

					if(d === 'TOTALES'){
						$('td', row).attr('style', 'font-weight: bold;text-align: right;');
						$('td:eq(0)', row).attr('style', 'font-weight: bold;text-align: right;');
					}
				});
				
			}	
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	table_destiny(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
					extend: 'excelHtml5',
					title: this.state.filename
				},
				{
					extend: 'pdf',
					title: this.state.filename,
					customize: (doc)=> { 
						doc.content.unshift({
							image: this.props.header_document,
							//text:'encabezado',
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 0){
								head.push({text:c.title, style:'tableHeader'})
							}
							
						})

						this.state.list_pdf.unshift(head);
						
						doc.content[3].table.body = this.state.list_pdf;

						doc.content[3].table.body.map((b, i)=>{	
							b.map((item, j)=>{
								if(j > 0){
									item.alignment = 'right';
								}
							})
						})

						doc.content[3].table.widths= this.state.type === 'component_service' ?
														['40%', '5%', '5%', '5%', '5%', '5%', '5%', '10%', '10%', '10%']
														: ["55%","15%","15%","15%"];
						
						doc.styles.tableHeader.fontSize = 6.5;
						doc.defaultStyle.fontSize = 6.5; 
						doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
					} 
				}
			],
			rowGroup: {dataSrc: 0 },
			columnDefs: [
				{
					targets: [0],
					visible: false
				},
				{
					targets:this.state.type === 'component_service' ? [2,3,4,5,6,7,8,9,10] : [2,3,4],
					className: 'dt-right'
				}
			],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				data.map((d, i)=>{
					if(d === 'TOTAL'){
						$('td', row).attr('style', 'font-weight: bold;text-align: right;borderTop:1px solid #3e3e3e');
						$('td:eq(0)', row).attr('style', 'font-weight: bold;text-align: right;');
					}	
				});

								
			}
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/transfusion_statistics_volume',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: response,
						});

						var list = [];
						var list_pdf = [];
						var total = 0;
						var obj = [];
						var obj_pdf = [];
						var totales = [];


						response.map((d)=>{
									obj = [];
									
									
									list_pdf.push(obj_pdf);
									obj_pdf=[];
							
									obj.push(
										d.COMPONENTE,   
										d.CON_VOLUMEN,  
										d.VOLUMEN_ML,    
										d.SIN_VOLUMEN 
									);
									

									obj_pdf.push(
										{text:d.component},
										{text:d.con_vol,alignment:'right'},
										{text:d.tot_vol,alignment:'right'},
										{text:d.sin_vol,alignment:'right'},
									)

									list.push(obj);
									 list_pdf.push(obj_pdf);
								})

								list.push([
									'TOTALES',
									response.reduce((suma, item) => suma + Number(item.CON_VOLUMEN),0),
									response.reduce((suma, item) => suma + Number(item.VOLUMEN_ML),0),
									response.reduce((suma, item) => suma + Number(item.SIN_VOLUMEN),0)]
								) 

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							if(this.state.type === 'destiny_component' || this.state.type === 'component_service'){
								this.table_destiny();
							}else{
								this.setTable();
							}
						}, 1000);

						this.setState({
							listado: list,
							list_pdf:list_pdf,
							totales:totales
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
		let isFormValid = true;
		
		inputs.forEach(input => {
			if(input.required){
				
				const isInputValid = this.showCtrlError(input.name);
				if (!isInputValid) {
					isFormValid = false;
				}
				
		   
			}
		});	    

		return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					{this.state.filename}
					</h5>
				</div>
				{/* <Help 
					{...this.props}
					menu={"help_patients"} 
					submenu={"help_units_delivered_stats"}  /> */}
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>


								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
										
									</div>
								</div>
								<div className="col-xs-12 form-group">
									{this.state.type === 'destiny_component' ?
										<table className="table">
											<tbody>
												<tr>
													{this.state.totales.map((t, i)=>(
														<td key={i} style={
															i === 2 ? {textAlign:'right', width:'22%'}
															:i === 3 ? {textAlign:'right', width:'16%'}
															:i === 4 ? {textAlign:'right', width:'21%'}	
															: {textAlign:'right'}
														}>{t}</td>	
													))}
												</tr>
											</tbody>
										</table>
									:null}
								</div>
								{this.state.type === 'component_service' &&
									<div className="col-xs-12 form-group">
										<table className="table">
											
											<tbody>
												<tr>
													{this.state.totales.map((t, j)=>
														j === 0 ?
															<td key={j} style={{width:'29%'}}>{t}</td>
														:
															<td style={{textAlign:'right'}}>{t}</td>
													)}
												</tr>
												
											</tbody>
										</table>
									</div>
								}
								
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (TransfusionStatisticsVolume);